import { cloneDeep } from "lodash";
import { SubscriberBackendCredentials } from "../interfaces/SubscriberBackendCredentials";

interface ValueWrapped {
	key: string|number;
	value: string;
}

interface InterfacenetTipoProdutoMasterWrapper {
	enum: InterfacenetTipoProdutoMasterEnum;
	description: string;
}

export enum InterfacenetTipoProdutoMasterEnum {
    Cor,
    Tamanho,
    CorTamanho,
    TamanhoCor,
    Normal,
}

export class SubscriberBackendInterfacenetCredentialsModel {
	static getTypeProductMasterList():InterfacenetTipoProdutoMasterWrapper[] {
		return [
			{enum: InterfacenetTipoProdutoMasterEnum.Cor, description: 'Cor'},
			{enum: InterfacenetTipoProdutoMasterEnum.Tamanho, description: 'Tamanho'},
			{enum: InterfacenetTipoProdutoMasterEnum.CorTamanho, description: 'Cor/Tamanho'},
			{enum: InterfacenetTipoProdutoMasterEnum.TamanhoCor, description: 'Tamanho/Cor'},
			{enum: InterfacenetTipoProdutoMasterEnum.Normal, description: 'Normal'},
		]
	}

	isActive: boolean = false;
	clientId: string = "";
	clientSecret: string = "";
	clientName: string = "";
	redeStock: string|ValueWrapped = "";
	filialStock: string[]|ValueWrapped[] = [];
	filialSales: string|ValueWrapped = "";
	priceTable: string|ValueWrapped = "";
	defaultWeight: number = 0;
	defaultWidth: number = 0;
	defaultHeight: number = 0;
	defaultDepth: number = 0;
	codigoVendedorPadrao: string = "";
	tipoProdutoMasterWrapper: InterfacenetTipoProdutoMasterWrapper|null = null;
	tipoProdutoMaster: InterfacenetTipoProdutoMasterEnum;

	constructor(s?:Partial<SubscriberBackendInterfacenetCredentialsModel>) {
		Object.assign(this, s);

		this._parseTypeProductMasterWrapper();
	}

	setRedeStock(list:ValueWrapped[]):void {
		this.redeStock = list.find((info) => info.key === this.redeStock) as ValueWrapped || {}
	}

	setFilialSales(list:ValueWrapped[]):void {
		this.filialSales = list.find((info) => info.key === this.filialSales) as ValueWrapped || {}
	}

	setPriceTable(list:ValueWrapped[]):void {
		this.priceTable = list.find((info) => info.key === Number(this.priceTable)) as ValueWrapped || {}
	}

	setFilialStock(list:ValueWrapped[]):void {
		const finalFilialStock = [];

		for (const chosenStock of this.filialStock) {
			if (list.map((info) => info.key).includes(chosenStock as string)) {
				finalFilialStock.push(list.find((info) => info.key === chosenStock))
			}
		}

		this.filialStock = cloneDeep(finalFilialStock) as ValueWrapped[];
	}

	hasAllBasicInfo():boolean {
		return !!this.clientId &&
			!!this.clientSecret &&
			!!this.clientName &&
			!!this.redeStock
	}

	normalize():SubscriberBackendCredentials {
		return {
			...this,
			// @ts-ignore
			filialStock: (this.filialStock as string).map((s) => s.key),
			// @ts-ignore
			filialSales: this.filialSales?.key as ValueWrapped,
			// @ts-ignore
			priceTable: this.priceTable?.key as ValueWrapped,
			// @ts-ignore
			redeStock: this.redeStock?.key as ValueWrapped,
			tipoProdutoMasterWrapper: undefined,
			// @ts-ignore
			tipoProdutoMaster: this.tipoProdutoMasterWrapper?.enum,
		}
	}

	private _parseTypeProductMasterWrapper():void {
		this.tipoProdutoMasterWrapper = SubscriberBackendInterfacenetCredentialsModel
			.getTypeProductMasterList()
			.find((item) => item.enum === this.tipoProdutoMaster) || null;
	}
}
